import * as angular from "angular";
import {CommonsService} from "../commons/services/commons-service.service";

angular
  .module('bringoz.admin.timekeeping')
  .config(timekeepingConfig);

/* @ngInject */
function timekeepingConfig($stateProvider) {

  $stateProvider

    // Timekeeping
    .state('timekeeping', {
      parent: 'bringoz.site',
      url: '/timekeeping?from&to&groupTags&groupIds&branchIds&tags&statuses&query&displayStatusGroups',
      template: '<app-timekeeping-view [from]="vm.from" [to]="vm.to" [group-tags]="vm.groupTags" [group-ids]="vm.groupIds" [branch-ids]="vm.branchIds" [tags]="vm.tags" [statuses]="vm.statuses" [query-string]="vm.queryString" [display-status-groups]="vm.displayStatusGroups"></app-timekeeping-view>',
      controllerAs: 'vm',
      controller: function ($stateParams, triBreadcrumbsService, commonsService: CommonsService, site) {
        this.from = $stateParams.from ? parseInt($stateParams.from) : undefined;
        this.to = $stateParams.to ? parseInt($stateParams.to) : undefined;
        this.groupTags = commonsService.parseArrayStateParam($stateParams.groupTags) || [];
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || [];
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || [];
        this.statuses = commonsService.parseArrayStateParam($stateParams.statuses) || [];
        this.displayStatusGroups = commonsService.parseArrayStateParam($stateParams.displayStatusGroups) || [];
        this.queryString = $stateParams.query;
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Timekeeping"});
        triBreadcrumbsService.addCrumb({name: "Resources"});
      }
    })

    // Timecard Detail
    .state('timecardDetail', {
      parent: 'bringoz.site',
      url: '/timekeeping/detail?agentId&from&to&listFrom&listTo&groupTags&groupIds&branchIds&tags&statuses&query&displayStatusGroups',
      template: '<timecard-detail-view agent-id="vm.agentId" from-date="vm.fromDate" to-date="vm.toDate" list-from="vm.listFrom" list-to="vm.listTo" group-tags="vm.groupTags" group-ids="vm.groupIds" branch-ids="vm.branchIds" tags="vm.tags" statuses="vm.statuses" query-string="vm.queryString" display-status-groups="vm.displayStatusGroups"></timecard-detail-view>',
      controllerAs: 'vm',
      controller: function ($stateParams, triBreadcrumbsService, commonsService: CommonsService, site) {
        this.agentId = $stateParams.agentId;
        this.fromDate = $stateParams.from ? parseInt($stateParams.from) : undefined;
        this.toDate = $stateParams.to ? parseInt($stateParams.to) : undefined;
        this.listFrom = $stateParams.listFrom ? parseInt($stateParams.listFrom) : undefined;
        this.listTo = $stateParams.listTo ? parseInt($stateParams.listTo) : undefined;
        this.groupTags = commonsService.parseArrayStateParam($stateParams.groupTags) || [];
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || [];
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || [];
        this.statuses = commonsService.parseArrayStateParam($stateParams.statuses) || [];
        this.displayStatusGroups = commonsService.parseArrayStateParam($stateParams.displayStatusGroups) || [];
        this.queryString = $stateParams.query;
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Timecard Detail"});
        triBreadcrumbsService.addCrumb({name: "Timekeeping"});
        triBreadcrumbsService.addCrumb({name: "Resources"});
      }
    })

}

